/**
 * Animation variants for the ComparisonModals components
 * Using framer-motion for smooth animations
 */

// Backdrop animation variants
export const backdropVariants = {
  hidden: { 
    opacity: 0 
  },
  visible: { 
    opacity: 1,
    transition: { 
      duration: 0.3,
      ease: 'easeOut'
    }
  },
  exit: { 
    opacity: 0,
    transition: { 
      duration: 0.3,
      ease: 'easeIn',
      delay: 0.1
    }
  }
};

// Selection modal animation variants (slides in from right)
export const selectionModalVariants = {
  hidden: { 
    x: '100%',
    transition: { 
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }
  },
  visible: { 
    x: 0,
    transition: { 
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1],
      when: 'beforeChildren',
      staggerChildren: 0.1
    }
  },
  exit: { 
    x: '100%',
    transition: { 
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1],
      when: 'afterChildren',
      staggerChildren: 0.05,
      staggerDirection: -1
    }
  }
};

// Comparison modal animation variants (slides in from left)
export const comparisonModalVariants = {
  hidden: { 
    x: '-100%',
    transition: { 
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }
  },
  visible: { 
    x: 0,
    transition: { 
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1],
      when: 'beforeChildren',
      staggerChildren: 0.1
    }
  },
  exit: { 
    x: '-100%',
    transition: { 
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1],
      when: 'afterChildren',
      staggerChildren: 0.05,
      staggerDirection: -1
    }
  }
};

// Content animation variants for staggered children
export const contentVariants = {
  hidden: { 
    opacity: 0, 
    y: 10 
  },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.3, 
      ease: 'easeOut' 
    }
  },
  exit: { 
    opacity: 0, 
    y: 5,
    transition: { 
      duration: 0.2, 
      ease: 'easeIn' 
    }
  }
};

// Button hover animation
export const buttonHoverVariants = {
  initial: { 
    scale: 1 
  },
  hover: { 
    scale: 1.05,
    transition: { 
      duration: 0.2, 
      ease: 'easeInOut' 
    }
  },
  tap: { 
    scale: 0.95,
    transition: { 
      duration: 0.1, 
      ease: 'easeInOut' 
    }
  }
};

// Card hover animation
export const cardHoverVariants = {
  initial: { 
    y: 0,
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
  },
  hover: { 
    y: -5,
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    transition: { 
      duration: 0.3, 
      ease: 'easeOut' 
    }
  }
};

// Fade in animation
export const fadeInVariants = {
  hidden: { 
    opacity: 0 
  },
  visible: { 
    opacity: 1,
    transition: { 
      duration: 0.5 
    }
  },
  exit: { 
    opacity: 0,
    transition: { 
      duration: 0.3 
    }
  }
};

// Slide up animation
export const slideUpVariants = {
  hidden: { 
    y: 20, 
    opacity: 0 
  },
  visible: { 
    y: 0, 
    opacity: 1,
    transition: { 
      duration: 0.4, 
      ease: 'easeOut' 
    }
  },
  exit: { 
    y: 20, 
    opacity: 0,
    transition: { 
      duration: 0.3, 
      ease: 'easeIn' 
    }
  }
};

// Scale animation
export const scaleVariants = {
  hidden: { 
    scale: 0.8, 
    opacity: 0 
  },
  visible: { 
    scale: 1, 
    opacity: 1,
    transition: { 
      duration: 0.4, 
      ease: [0.16, 1, 0.3, 1] 
    }
  },
  exit: { 
    scale: 0.8, 
    opacity: 0,
    transition: { 
      duration: 0.3, 
      ease: [0.16, 1, 0.3, 1] 
    }
  }
};

// Transition between recommendation steps
export const stepTransitionVariants = {
  enter: (direction) => ({
    x: direction > 0 ? '100%' : '-100%',
    opacity: 0
  }),
  center: {
    x: 0,
    opacity: 1,
    transition: {
      x: { 
        type: 'spring', 
        stiffness: 300, 
        damping: 30 
      },
      opacity: { 
        duration: 0.2 
      }
    }
  },
  exit: (direction) => ({
    x: direction < 0 ? '100%' : '-100%',
    opacity: 0,
    transition: {
      x: { 
        type: 'spring', 
        stiffness: 300, 
        damping: 30 
      },
      opacity: { 
        duration: 0.2 
      }
    }
  })
};